import ExcelJS from 'exceljs';
import { downloadWorkbook, setColWidths } from '../../documentos/commercialExcelUtils';
import { insertHtFooterTextBoxes } from './htFooterTextBoxes';
import { htFileBase } from './buildHtParams';
import { addHtSheetImages } from './htSheetImages';
import {
  applyHtSheetBorders,
  HT_COL_WIDTHS,
  HT_ROW_END,
  prepareHtSheetStructure,
  writeHtSheetValues,
} from './htSheetLayout';

export function htExcelFileName(params) {
  return `${htFileBase(params)}.xlsx`;
}

export async function buildHtExcelWorkbook(params) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('HT');
  setColWidths(ws, HT_COL_WIDTHS);

  prepareHtSheetStructure(ws);
  writeHtSheetValues(ws, params);
  applyHtSheetBorders(ws);
  await addHtSheetImages(ws, wb);

  ws.pageSetup = {
    orientation: 'portrait',
    paperSize: 9,
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: { left: 0.35, right: 0.35, top: 0.35, bottom: 0.35, header: 0, footer: 0 },
  };
  ws.pageSetup.printArea = `C5:E${HT_ROW_END}`;
  ws.views = [{ showGridLines: false }];

  return wb;
}

export async function generateHtExcel(params) {
  const wb = await buildHtExcelWorkbook(params);
  const buffer = await wb.xlsx.writeBuffer();
  const withFooterText = await insertHtFooterTextBoxes(buffer, params.static);
  downloadWorkbook(withFooterText, htExcelFileName(params));
}
